import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface ReplaceProgramConfirmDialogProps {
  open: boolean;
  isReplacing?: boolean;
  confirmDisabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ReplaceProgramConfirmDialog = ({
  open,
  isReplacing = false,
  confirmDisabled = false,
  onCancel,
  onConfirm,
}: ReplaceProgramConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={isReplacing ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle variant="dialogTitle" align="center">
        <Trans i18nKey="replaceProgramDialog.title">Warning</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3, px: 3 }}>
        <Stack spacing={2}>
          <Typography variant="body1" component="p">
            <Trans i18nKey="replaceProgramDialog.body">Are you sure you want to replace your current program code? This cannot be undone.</Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'center', px: 2, py: 2 }}>
        <Stack direction="row" spacing={2}>
          <Button variant="text" onClick={onCancel} disabled={isReplacing}>
            <Trans i18nKey="replaceProgramDialog.cancel">Cancel</Trans>
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm} disabled={isReplacing || confirmDisabled}>
            <Trans i18nKey="replaceProgramDialog.confirm">Confirm</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ReplaceProgramConfirmDialog;
